import { getToken, setToken, isValid, isExpired } from "./utils";
import ccFetch from "../ccFetch";
// import { AuthenticationError } from "@contcontrol/cc-errors";

class AuthenticationError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.alias = "Erro de autenticação";
  }
}


export default function(params) {
  // params are injected on lib import
  const { authDomain, authRenewUri, notAuthenticated, tokenChanged } = params;
  let renewFullUrl = `${authDomain}${authRenewUri}`
  return function(apiCaller) {
    // apiCaller is the function that will be the interface between front and back-end
    // (fetch or axios, for example...)
    return function() {
          // return new Promise((resolve,reject) => {
      let tk = getToken();
      if (!isValid(tk)) {
        console.error("Token inválido ou inexistente.");
        notAuthenticated()
        return Promise.reject(new AuthenticationError("Não autenticado"));
      } else if (isExpired(tk)) {
        // console.log("Token expirado, tentando renovar...");
        return ccFetch(renewFullUrl, {
          method: "post",
          headers: {
            "Content-Type": "application/json"
          }
        })
          .then(r => r.json())
          .then(r => setToken(r.tk))
          .then(tokenChanged)
          // .then(r => apiCaller.apply(this, arguments))
          .then(r => Promise.all(
            arguments[0].map(arg => apiCaller.apply(this, [arg]))
          ))
          .then(r => Promise.resolve(r))
          .catch(err => {
            console.error("Falha ao renovar token...", err);
            // notAuthenticated();
            return Promise.reject(new AuthenticationError("Token não foi renovado com sucesso, favor re-autenticar"));
          });
      } else {
        // console.log("Token válido e ativo, prosseguindo...");
        // return Promise.resolve(apiCaller.apply(this, arguments));
        return Promise.resolve(Promise.all(
          arguments[0].map(arg => apiCaller.apply(this, [arg]))
        ))
      }
    };
    // })
  };
}
